import React, { Fragment } from 'react';
import DateTime from './DateTime/DateTime';

const test = (props) => (
    <Fragment><DateTime /></Fragment>
);

export default test;



// WEBPACK FOOTER //
// ./src/containers/Test/Test.js